import _isEmpty from 'lodash/isEmpty';
export function createAddressComponents(address) {
  var street = address.street,
    city = address.city,
    state = address.state,
    zip = address.zip,
    country = address.country;
  var components = [];
  if (city) components.push(city);
  if (state) components.push(state);
  var locality = components.join(', ');
  if (zip) {
    locality = locality ? "".concat(locality, " ").concat(zip) : zip;
  }
  return {
    street: street,
    locality: locality,
    country: country
  };
}
export function getFormattedAddress(address, showCountry) {
  var _createAddressCompone = createAddressComponents(address),
    street = _createAddressCompone.street,
    locality = _createAddressCompone.locality,
    country = _createAddressCompone.country;
  var components = [];
  if (street) components.push(street);
  if (locality) components.push(locality);
  if (showCountry && country) components.push(country);
  return components.join(', ');
}
export function getLocationDisplayName(locationName, address, showCountry) {
  if (!locationName && _isEmpty(address)) return null;
  if (locationName) return locationName;
  return getFormattedAddress(address, showCountry);
}